/* ==========================================================================
   FORTE · CART DRAWER behaviour

   Every mutation goes through Shopify's Cart AJAX API and the drawer is then
   re-rendered from the Section Rendering API, so the meter, the totals and the
   upsell list are always what Shopify actually holds rather than something this
   file tried to keep in step.
   ========================================================================== */

(function () {
  /* ---------------------------------------------------------------- gate

     The drawer ships on the master theme next to the current cart so the two
     can be split tested on one theme. `forte_cart_mode` (theme setting, read
     off the section root as data-fc-mode) decides whether this file does
     anything:

       on    — take over for everyone.
       test  — take over only when <html> carries `ig-forte-cart`, which the
               Intelligems variant adds. Control visitors never reach init(),
               so the SlideCart app / stock drawer keep working untouched.
       off   — the section is not rendered, so this file is not loaded.

     The Intelligems bundle and this file both load async, so in test mode we
     wait a few seconds for the class before deciding "control". */
  var FLAG = 'ig-forte-cart';

  function mode() {
    var r = document.querySelector('[data-fc]');
    return (r && r.getAttribute('data-fc-mode')) || 'off';
  }

  function flagged() {
    return document.documentElement.classList.contains(FLAG);
  }

  function boot() {
    var m = mode();
    if (m === 'on') return init();
    if (m !== 'test') return;
    if (flagged()) return init();
    var tries = 0;
    var t = setInterval(function () {
      if (flagged()) { clearInterval(t); init(); }
      else if (++tries >= 50) clearInterval(t); /* 5 s: control group */
    }, 100);
  }

  /* ---------------------------------------------------- one cart, not three

     Broadcast still renders its own #cart-drawer (enable_cart_dropdown) and
     binds the header icon to it, and the SlideCart app binds the same icon and
     also opens itself on every add. Which one a visitor saw depended on which
     script had finished loading when they clicked, so the control and variant
     of a page test could show different carts. Until the Forte drawer takes
     over (html.fc-active), the icon opens SlideCart only, and the theme drawer
     is closed the moment it tries to open (its panel is hidden in CSS too). */
  function slideCartOpen() {
    if (typeof window.SLIDECART_OPEN === 'function') { window.SLIDECART_OPEN(); return; }
    var n = 0;
    var t = setInterval(function () {
      if (typeof window.SLIDECART_OPEN === 'function') { clearInterval(t); window.SLIDECART_OPEN(); }
      else if (++n >= 30) { clearInterval(t); window.location.href = '/cart'; }
    }, 100);
  }

  document.addEventListener('click', function (e) {
    if (document.documentElement.classList.contains('fc-active')) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var toggle = t.closest('[data-cart-toggle]');
    if (!toggle || toggle.closest('#cart-drawer')) return;
    e.preventDefault();
    e.stopPropagation();
    slideCartOpen();
  }, true);

  document.addEventListener('theme:cart:open', function () {
    if (document.documentElement.classList.contains('fc-active')) return;
    /* Broadcast opens, then locks scroll and traps focus. A click outside the
       drawer is its own close path, so give it one a tick later. */
    setTimeout(function () {
      var d = document.getElementById('cart-drawer');
      if (d && d.classList.contains('is-open')) document.body.click();
      /* The theme only opens its drawer after a successful add (quick-add on
         the stock collection cards), and SlideCart does not watch those adds,
         so show SlideCart with the fresh cart in its place. */
      if (typeof window.SLIDECART_UPDATE === 'function') { try { window.SLIDECART_UPDATE(); } catch (err) {} }
      slideCartOpen();
    }, 60);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  function init() {
  document.documentElement.classList.add('fc-active');
  var SECTION = 'forte-cart-drawer';
  var root = null;

  function el() {
    root = document.querySelector('[data-fc]');
    return root;
  }

  /* ---------------------------------------------------------------- open/close */

  var returnFocus = null;

  function open() {
    if (!el()) return;
    if (root.hidden) returnFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('fc-open');
    document.body.style.overflow = 'hidden';

    var close = root.querySelector('[data-fc-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function close() {
    if (!el()) return;
    root.hidden = true;
    document.documentElement.classList.remove('fc-open');
    document.body.style.overflow = '';
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }

  /* A re-render replaces the whole drawer, which would drop focus to <body>
     after every quantity or plan click. Remember which control had it (by its
     line and data attribute) and put it back on the same control. */
  function focusKey() {
    var a = document.activeElement;
    if (!a || !root || !root.contains(a)) return null;
    var line = a.closest('[data-fc-line]');
    var attr = [].slice.call(a.attributes).filter(function (x) { return x.name.indexOf('data-fc-') === 0; })[0];
    if (!attr) return null;
    return (line ? '[data-fc-line="' + line.getAttribute('data-fc-line') + '"] ' : '') + '[' + attr.name + '="' + attr.value.replace(/"/g, '\\"') + '"]';
  }

  function focusables() {
    return [].slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (n) { return n.offsetParent !== null; });
  }

  /* ------------------------------------------------------------------- refresh */

  /* The markup and the cart are two separate requests, so they go out together
     rather than one after the other, and the single cart object is then handed
     to everything that needs it. Before this, one add fetched /cart.js three or
     four times over — once here, once for the count, once for the gift check —
     each one waiting on the last. */
  function refresh(preloaded, settling) {
    var sectionP = fetch('?section_id=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); });

    var cartP = preloaded
      ? Promise.resolve(preloaded)
      : fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });

    return Promise.all([sectionP, cartP]).then(function (both) {
      var html = both[0];
      var cart = both[1];
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fc]');

      if (next && el()) {
        /* The drawer is open while this happens, so carry the open state over
           rather than letting the freshly parsed markup close it. */
        var wasOpen = !root.hidden;
        var key = focusKey();
        root.replaceWith(next);
        root = next;
        root.hidden = !wasOpen;
        if (key) {
          var again = root.querySelector(key);
          if (again) again.focus({ preventScroll: true });
        }
      }

      syncCount(cart);
      carousel();
      gift(cart);
      if (!settling) settle(cart);
      return cart;
    });
  }

  /* EP 2026-10-27: the gift app adds the promo gift first and Shopify only
     makes it $0 a moment later, so a drawer drawn straight after the add kept
     showing the gift at full price. Look at the cart again shortly after each
     refresh and redraw once if Shopify's total has moved since. */
  var settleTimers = [];

  function settle(drawn) {
    settleTimers.forEach(clearTimeout);
    settleTimers = [1000, 2500, 5000, 8000].map(function (ms) {
      return setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (now) {
            if (!drawn || !now) return;
            if (ms >= 5000) tierCheck(now);
            if (now.total_price === drawn.total_price && now.item_count === drawn.item_count) return;
            drawn = now;
            return refresh(now, true);
          })
          .catch(function () {});
      }, ms);
    });
  }

  /* EP 2026-10-27: Anniversary promo gifts (Discount Ninja "Anniversary Sale
     2026 - Gifts", 24 Oct to 9 Nov). Without its page reload, Discount Ninja
     still adds and removes gifts in place, but once it has taken a gift out
     (cart dropped below that tier) it will not put it back until the next page
     load. So if the cart has reached a tier and that tier's gift is still
     missing a few seconds after a change, the page is reloaded once and the
     drawer opens again straight away. Each cart state is only tried once, so
     this can never loop. */
  var PROMO_END = Date.UTC(2026, 10, 10, 8, 0, 0);
  var TIERS = [
    { cents: 5400, handles: ['round-brush'] },
    { cents: 9400, handles: ['new-dopp-kit-2024'] },
    { cents: 14400, handles: ['protagonist'] },
    { cents: 18400, handles: ['antagonist', 'atomizer'] }
  ];
  var REOPEN = 'fc-reopen-after-gift';

  function giftMissing(cart) {
    if (Date.now() > PROMO_END || !cart || !cart.items) return false;
    var have = {};
    cart.items.forEach(function (it) { have[it.handle] = true; });
    return TIERS.some(function (tier) {
      return cart.total_price >= tier.cents && tier.handles.some(function (h) { return !have[h]; });
    });
  }

  function tierCheck(cart) {
    if (!giftMissing(cart)) return;
    var key = cart.total_price + ':' + cart.item_count;
    try {
      if (sessionStorage.getItem(REOPEN + '-tried') === key) return;
      sessionStorage.setItem(REOPEN + '-tried', key);
      sessionStorage.setItem(REOPEN, String(Date.now()));
    } catch (e) { return; }
    window.location.reload();
  }

  /* Keep the header's bubble honest — it is the theme's markup, so this only
     writes the number, it does not try to own it. */
  function syncCount(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count], .header__cart__status').forEach(function (n) {
      n.textContent = cart.item_count;
    });
  }

  /* -------------------------------------------------------------- cart writes */

  function busy(on) {
    if (el()) root.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function changeLine(line, quantity, sellingPlan) {
    var body = { line: line, quantity: quantity };

    /* An empty string is a real value here: it means "take this line off its
       plan". Undefined would leave the plan untouched. */
    if (sellingPlan !== undefined) body.selling_plan = sellingPlan === '' ? null : Number(sellingPlan);

    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function () { return refresh(); })
      .then(function () { busy(false); })
      .catch(function () { busy(false); });
  }

  function addVariant(id) {
    busy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function () { return refresh(); })
      .then(function () { busy(false); })
      .catch(function () { busy(false); });
  }

  /* ------------------------------------------------------------------ wiring */

  /* One delegated listener on the document, so it keeps working after the
     drawer has been replaced by a re-render. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Anything that opens the cart opens this one. The theme's own drawer is
       bound to the same [data-cart-toggle], so the click is stopped here before
       it reaches that handler. */
    var toggle = t.closest('[data-cart-toggle], [data-fc-open]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      open();
      return;
    }

    if (t.closest('[data-fc-close]')) {
      e.preventDefault();
      close();
      return;
    }

    if (!el() || root.hidden) return;

    var qty = t.closest('[data-fc-qty]');
    if (qty) {
      var lineEl = qty.closest('[data-fc-line]');
      if (lineEl) changeLine(Number(lineEl.dataset.fcLine), Number(qty.dataset.fcQty));
      return;
    }

    var plan = t.closest('[data-fc-plan]');
    if (plan) {
      var host = plan.closest('[data-fc-line]');
      if (host && !plan.classList.contains('is-on')) {
        /* EP 2026-10-27: a plan change sent without a quantity reset the line
           to 1, so the line's current quantity goes with it. */
        var n = host.querySelector('.fc-li__n');
        var qtyNow = n ? Number(n.textContent) : NaN;
        changeLine(Number(host.dataset.fcLine), qtyNow > 0 ? qtyNow : undefined, plan.dataset.fcPlan);
      }
      return;
    }

    var add = t.closest('[data-fc-add]');
    if (add) {
      add.disabled = true;
      addVariant(add.dataset.fcAdd);
      return;
    }
  }, true);

  /* ------------------------------------------- open on the click itself

     Several different scripts can perform an add on this store — the PDP's own
     form handler, Broadcast's quick-add, the SlideCart app — and each finishes
     at a different moment. Waiting for whichever one wins is what made the cart
     feel slow: the panel only appeared once the add AND the re-render had come
     back, well over a second later.

     The panel is already in the page, so it is shown on the click instead, and
     whichever path handles the add refreshes it in place afterwards. This only
     reveals what is already there; it does not add anything itself. */
  function isAddControl(t) {
    if (!t || !t.closest) return null;

    var ctl = t.closest(
      '[data-fpdp-submit], [data-quick-add-btn], [data-quick-add-btn-mobile],' +
      ' button[type="submit"], input[type="submit"]'
    );
    if (!ctl || ctl.disabled) return null;

    /* A submit button only counts when it belongs to an add-to-cart form. */
    if (ctl.type === 'submit' && !ctl.hasAttribute('data-fpdp-submit')) {
      var form = ctl.form || ctl.closest('form');
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return null;
    }

    return ctl;
  }

  document.addEventListener('click', function (e) {
    if (!el() || !root.hidden) return;          /* already open */
    if (e.target.closest('[data-fc]')) return;  /* clicks inside the drawer */
    if (!isAddControl(e.target)) return;

    open();
    busy(true);

    /* If nothing refreshes it shortly — a validation failure, say — stop
       showing it as busy rather than leaving a spinner on forever. */
    setTimeout(function () { busy(false); }, 4000);
  }, true);

  /* ------------------------------------------------------------- carousel */

  /* "Complete your routine" shows one card at a time with a 1 OF n counter.
     The slides all ship in the markup, so this only moves which one is on. */
  function carousel() {
    if (!el()) return;
    var box = root.querySelector('[data-fc-carousel]');
    if (!box) return;

    var slides = [].slice.call(box.querySelectorAll('.fc-up--slide'));
    if (!slides.length) return;

    var i = 0;
    var index = box.querySelector('[data-fc-index]');
    var total = box.querySelector('[data-fc-total]');
    if (total) total.textContent = slides.length;

    function paint() {
      slides.forEach(function (sl, n) { sl.classList.toggle('is-on', n === i); });
      if (index) index.textContent = i + 1;
    }

    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-fc-prev]')) { i = (i - 1 + slides.length) % slides.length; paint(); }
      if (e.target.closest('[data-fc-next]')) { i = (i + 1) % slides.length; paint(); }
    });

    paint();
  }

  /* ------------------------------------------------------------- free gift */

  /* The meter promises a comb at $30, and the cart has to keep that promise
     without ever charging for it.

     A theme cannot price a line at zero — Shopify prices are server-side, and
     only a discount can zero one. So the gift is handled two ways and the right
     one is worked out from what Shopify actually does:

       · a discount exists → the gift is a real cart line at $0, which is what
         the comp draws and what decrements inventory;
       · no discount → the gift rides as a cart ATTRIBUTE instead. The drawer
         still shows the row, the order still records the gift for whoever packs
         it, and the customer's total is untouched.

     Either way nothing is added to what they pay. */
  var giftBusy = false;
  var giftTried = false;
  var warned = false;

  function warnAttr() {
    if (warned) return;
    warned = true;
    console.info(
      '[Forte cart] Shopify charged for the gift, so it is travelling as the cart ' +
      'attribute instead of a real line — which means it will NOT appear in checkout.\n' +
      'The drawer adds 1 unit, so the discount has to pay out on 1 unit. Check, in ' +
      'Discounts:\n' +
      '  · Buy X get Y -> Customer gets -> Quantity = 1 (a higher number means the ' +
      'customer must have that many in the cart before anything is free)\n' +
      '  · Customer spends -> Purchase type = Both, or subscription carts will not qualify\n' +
      '  · the qualifying collection excludes the gift product itself'
    );
  }

  function giftLine(cart, handle) {
    var found = null;
    cart.items.forEach(function (it, n) {
      if (it.handle === handle) found = { line: n + 1, price: it.final_price };
    });
    return found;
  }

  function setLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function setAttr(name, value) {
    var attributes = {};
    attributes[name] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function gift(preloaded) {
    if (!el() || giftBusy) return;

    var handle = root.dataset.fcGiftHandle;
    var gate = Number(root.dataset.fcGiftCents || 0);
    var variant = Number(root.dataset.fcGiftVariant || 0);
    var attr = root.dataset.fcGiftAttr || 'Free gift';
    var title = root.dataset.fcGiftTitle || handle;
    var code = root.dataset.fcGiftCode;
    if (!handle || !gate || !variant) { /* EP 2026-10-16: gift switched off - clear any gift note a cart still carries */ if (!handle) { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (c.attributes && c.attributes[attr]) return setAttr(attr, ''); }).catch(function () {}); } return; }

    giftBusy = true;

    var cartP = preloaded
      ? Promise.resolve(preloaded)
      : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });

    cartP
      .then(function (cart) {
        var have = giftLine(cart, handle);
        var promised = cart.attributes && cart.attributes[attr];

        /* The gift never counts towards its own gate. */
        var qualifying = cart.total_price;
        cart.items.forEach(function (it) { if (it.handle === handle) qualifying -= it.line_price; });

        /* ---- below the gate: withdraw the gift, however it is being carried */
        if (qualifying < gate) {
          if (have) return setLine(have.line, 0).then(function () { return promised ? setAttr(attr, '') : null; }).then(function () { return refresh(); });
          if (promised) return setAttr(attr, '').then(function () { return refresh(); });
          return;
        }

        /* ---- a real line that Shopify is giving away: nothing to do */
        if (have && have.price === 0) {
          if (promised) return setAttr(attr, '').then(function () { return refresh(); });
          return;
        }

        /* ---- a real line Shopify is charging for: swap it for the promise */
        if (have && have.price > 0) {
          warnAttr();
          return setLine(have.line, 0)
            .then(function () { return setAttr(attr, product_name(cart, handle)); })
            .then(function () { return refresh(); });
        }

        /* ---- nothing in the cart yet, or the promise is standing in for a
                line. Either way, try once per page load for a real $0 line:
                that is the only way to notice that a discount has since been
                created, and without it a cart that once fell back to the
                promise would keep the promise forever. */
        if (giftTried) {
          if (promised) return;
          return setAttr(attr, title).then(function () { return refresh(); });
        }
        giftTried = true;

        var applied = code
          ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {})
          : Promise.resolve();

        return applied
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] })
            });
          })
          .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
          .then(function (r) { return r.json(); })
          .then(function (after) {
            var now = giftLine(after, handle);
            if (now && now.price > 0) {
              warnAttr();
              return setLine(now.line, 0)
                .then(function () { return setAttr(attr, product_name(after, handle)); })
                .then(function () { return refresh(); });
            }
            /* A real $0 line exists, so it is the gift now and it will show in
               checkout. Any promise left over from before is redundant. */
            if (promised) return setAttr(attr, '').then(function () { return refresh(); });
            return refresh();
          });
      })
      .then(function () { giftBusy = false; })
      .catch(function () { giftBusy = false; });
  }

  /* The attribute is what the packer reads, so it carries the product's name
     rather than its handle when the cart knows it. */
  function product_name(cart, handle) {
    var name = handle;
    cart.items.forEach(function (it) { if (it.handle === handle) name = it.product_title || it.title || handle; });
    return name;
  }

  document.addEventListener('keydown', function (e) {
    if (!el() || root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    /* aria-modal: Tab cycles inside the drawer instead of walking the page behind. */
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!root.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Back from a gift reload (see tierCheck): show the cart again. */
  try {
    var reopenAt = Number(sessionStorage.getItem(REOPEN) || 0);
    if (reopenAt) {
      sessionStorage.removeItem(REOPEN);
      if (Date.now() - reopenAt < 20000) open();
    }
  } catch (e) {}

  window.FORTE_CART_OPEN = open;
  window.FORTE_CART_CLOSE = close;
  window.FORTE_CART_REFRESH = refresh;

  /* A few theme scripts and sections still call the SlideCart globals, so this
     drawer answers to those names too.

     A plain assignment is not enough: the SlideCart app embed defines the same
     globals from its own bundle, and it loads AFTER this file, so it used to
     win — every caller then opened the app's old drawer instead of this one.
     So the names are claimed with a setter that keeps ours and swallows the
     app's assignment, and re-claimed for a few seconds in case the embed
     arrives late or redefines them outright. */
  function claim(name, fn) {
    try {
      Object.defineProperty(window, name, {
        configurable: true,
        get: function () { return fn; },
        set: function () {}
      });
    } catch (e) {
      window[name] = fn;
    }
  }

  function claimAliases() {
    claim('SLIDECART_OPEN', open);
    claim('SLIDECART_UPDATE', refresh);
    claim('SLIDECART_CLOSE', close);
  }

  /* ------------------------------------------- Discount Ninja, without the reload

     EP 2026-10-27: Discount Ninja adds and removes the promo gifts itself, and
     after each change it reloaded the whole page (its "reload page after cart
     adjustments" setting), because it does not know this drawer. That closed
     the cart and reloaded the site on every gift change, and the drawer could
     show the gift at full price in the moment before the reload.

     Its settings are read live from window.discountNinjaContext, so the reload
     is switched off here and it is given this drawer's refresh instead: it runs
     that after every gift change (and once more a moment later), once its own
     cart update is done, so the gift and its price show in place. The /cart
     page keeps its own reload setting. */
  function quietNinja() {
    var ctx = window.discountNinjaContext;
    var m = ctx && ctx.Settings && ctx.Settings.PriceUpdate && ctx.Settings.PriceUpdate.Mode;
    if (!m) return false;
    m.ReloadPageAfterCartAdjustments = false;
    m.DrawerCartRefreshMethod = 'window.FORTE_CART_REFRESH && window.FORTE_CART_REFRESH();';
    return true;
  }

  if (!quietNinja()) {
    var ninjaWaits = 0;
    var ninjaTimer = setInterval(function () {
      if (quietNinja() || ++ninjaWaits >= 40) clearInterval(ninjaTimer);
    }, 250);
  }
  claimAliases();
  var reclaims = 0;
  var reclaimTimer = setInterval(function () {
    claimAliases();
    if (++reclaims >= 24) clearInterval(reclaimTimer);
  }, 250);

  /* ------------------------------------------- the old cart, suppressed

     The SlideCart app is not only a theme app-embed: it also injects itself
     through a store-level script tag, so disabling the embed does not remove
     it and the theme cannot delete it. It opens itself whenever anything adds
     to the cart, which is how the OLD cart kept appearing.

     Its open state is a single class — #slidecarthq .slidecarthq-overlay.open
     — and it locks the page by setting body overflow. So when it opens, that
     is taken as the signal that something was added: its own panel is stood
     back down and the Forte drawer is shown in its place. The result is that
     every add-to-cart path in the store, whoever wrote it, lands here. */
  var legacyBusy = false;

  function standDownLegacy(host) {
    var panel = host.querySelector('.slidecarthq-overlay.open');
    if (!panel || legacyBusy) return;

    legacyBusy = true;
    panel.classList.remove('open');

    /* It locked the page on the way in. This drawer manages that itself, so
       only release it when this drawer is not the one holding it. */
    if (!document.documentElement.classList.contains('fc-open')) {
      document.body.style.overflow = '';
    }

    open();
    busy(true);
    refresh()
      .catch(function () {})
      .then(function () { busy(false); legacyBusy = false; });
  }

  function watchLegacy() {
    var host = document.getElementById('slidecarthq');
    if (!host) return false;

    new MutationObserver(function () { standDownLegacy(host); })
      .observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });

    standDownLegacy(host);
    return true;
  }

  /* The app injects its host late, so wait for it rather than assuming. */
  if (!watchLegacy()) {
    var waits = 0;
    var waitTimer = setInterval(function () {
      if (watchLegacy() || ++waits >= 60) clearInterval(waitTimer);
    }, 250);
  }

  /* ------------------------------------------- the theme's own add-to-cart

     Broadcast's quick-add on collection and product cards does its own AJAX
     add and then asks its drawer to open. That drawer is not rendered here, so
     the add used to succeed silently with no cart appearing at all. It
     announces itself on the document, so those announcements are what open
     this drawer. Debounced, because it fires more than one event per add. */
  var extTimer = null;

  function externalAdd() {
    open();
    busy(true);
    if (extTimer) clearTimeout(extTimer);
    extTimer = setTimeout(function () {
      extTimer = null;
      refresh()
        .then(function () { busy(false); })
        .catch(function () { busy(false); });
    }, 150);
  }

  ['theme:product:added', 'theme:product:add', 'theme:cart:add'].forEach(function (ev) {
    document.addEventListener(ev, externalAdd);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { carousel(); gift(); });
  } else {
    carousel();
    gift();
  }

  /* A plain form post to /cart/add from elsewhere on the page (the home page
     cards, the PDP buy box) should land in the drawer too. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (f.matches('#fpdp-product-form')) return; /* the PDP handles its own */

    e.preventDefault();

    /* Open first. The panel is on the page already, so it can be shown in the
       same frame as the click instead of waiting on the add and the re-render;
       aria-busy marks it as catching up while those finish. */
    open();
    busy(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(f)
    })
      .then(function () { return refresh(); })
      .then(function () { busy(false); })
      .catch(function () { busy(false); f.submit(); });
  }, true);
  } /* init */
})();
